module.exports = "/_next/static/images/Ryan_Wheeler-8ee0e3fa79fff117f7d848be1adc808f.webp";